import {
  audioLanePlaybackMask,
  audioLaneChoiceLabel,
  audioTranslationLanguageLabel,
} from './videoEditorAudioTranslation';

/** Per-lane subtitle visibility; defaults to mirroring active audio lanes. */
export function normalizeSubtitleLaneActiveFlags(timelineActive, laneCount) {
  const n = Math.max(1, Number(laneCount) || 1);
  const master = timelineActive?.subtitle !== false;
  const raw = Array.isArray(timelineActive?.subtitleLanes) ? timelineActive.subtitleLanes : null;
  const audioMask = audioLanePlaybackMask(timelineActive, n);
  const lanes = [];
  for (let i = 0; i < n; i += 1) {
    if (raw && raw[i] != null) lanes.push(Boolean(raw[i]));
    else lanes.push(Boolean(audioMask[i]));
  }
  return { master, lanes };
}

export function subtitleLanePlaybackMask(timelineActive, laneCount) {
  const { master, lanes } = normalizeSubtitleLaneActiveFlags(timelineActive, laneCount);
  if (!master) return lanes.map(() => false);
  return lanes;
}

export function subtitleLaneLabel(trackIdx, audioTrackMeta) {
  const meta = Array.isArray(audioTrackMeta) ? audioTrackMeta[trackIdx] : null;
  if (meta?.isTranslation && meta?.languageCode) {
    return `Subs (${audioTranslationLanguageLabel(meta.languageCode)})`;
  }
  const audioLabel = audioLaneChoiceLabel(trackIdx, audioTrackMeta);
  if (trackIdx === 0) return 'Subs (Original)';
  return `Subs (${audioLabel})`;
}

/** Ensure subtitle track array has one row per audio lane. */
export function padSubtitleTracksToAudioLanes(subtitleTracks, audioLaneCount) {
  const n = Math.max(1, Number(audioLaneCount) || 1);
  const out = Array.isArray(subtitleTracks) ? [...subtitleTracks] : [];
  while (out.length < n) out.push([]);
  return out.slice(0, n);
}
